import { BottomButton, InfoModal } from "components/reusables";
import React, { useState } from "react";

export function AboutApp(): JSX.Element {
  const [display, setDisplay] = useState<true | false>(false);

  return (
    <>
      <BottomButton position="left" onClick={() => setDisplay(true)}>
        About
      </BottomButton>
      <InfoModal
        show={display}
        onHide={() => setDisplay(false)}
        title="About This App"
        /* message="This application was created for the Boerigter Center for Calling and Career to show current and prospective students the opportunities available to them through a Hope College education. It was developed in the 2020–2021 academic year by computer science majors Jonathan Chaffer, Josie Crane, Nam Do, and Will von Seeger, under the supervision of Dr. Matt DeJongh and Dr. Mike Jipping." */
        message={`This application was created for the Hope College Education Department to show current and prospective students the opportunities available to them through the
        education department, and to display images and info of each current student and faculty member already in the education department. It was developed as a summer
         research project in 2022 by computer science majors Jake Peterson, Lu'o'ng Tran, and Cadence Tennant,
         under the supervision of Dr. Mike Jipping.  
         Hope College grads are well equipped for teaching the next generation of young minds how to think critically in both school and life. We wish the best of luck to all of our
         education students and graduates! ---------------------------------------------------------------------------------------------------------  Copyright 2022 Hope College Software Institute`}
      />
    </>
  );
}
